module.exports = __webpack_public_path__ + "static/media/back.0587a4e0.svg";